// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2iB1Z","overflowing":"ReadFullNote_overflowing__2DgqZ"};